import http from 'plugins/axios';

export default {
  getCurrencyIntroductionList(data) {
    return http.get({
      url: '/admin/currency/introduction/list',
      data
    });
  },
  getCurrencyIntroductionDetail(id) {
    return http.get({
      url: '/admin/currency/introduction/detail',
      data: {
        id
      }
    });
  },
  createCurrencyIntroduction(data) {
    return http.post({
      url: '/admin/currency/introduction/create',
      data
    });
  },
  updateCurrencyIntroduction(data) {
    return http.post({
      url: '/admin/currency/introduction/update',
      data
    });
  },
  removeCurrencyIntroduction(id) {
    return http.post({
      url: '/admin/currency/introduction/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
